import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { setAuth } from "../../auth";
import { apiUrl } from "../../appConfig";

export function Login() {
  const [loginName, setLoginName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  async function submit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(apiUrl("/api/auth/login"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ loginName, password })
      });
      if (!res.ok) {
        const txt = await res.text();
        throw new Error(txt || "登录失败");
      }
      const data = await res.json();
      setAuth({
        token: data.token,
        expiresAt: data.expiresAt,
        loginName: data.loginName,
        realName: data.realName,
        role: data.role,
        customerId: data.customerId
      });
      const next = location.state?.from || "/gps-monitor";
      navigate(next, { replace: true });
    } catch (err) {
      setError(err.message || "登录失败");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="row justify-content-center mt-5">
      <div className="col-md-4">
        <div className="card shadow-sm status-card">
          <div className="card-header bg-dark text-white">MycGps 登录</div>
          <div className="card-body">
            <form onSubmit={submit}>
              <div className="mb-3">
                <label className="form-label">账号</label>
                <input
                  className="form-control"
                  value={loginName}
                  onChange={(e) => setLoginName(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">密码</label>
                <input
                  type="password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              {error && <div className="status-banner error">{error}</div>}
              <button className="btn btn-primary w-100" type="submit" disabled={loading}>
                {loading ? "登录中..." : "登录"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
